import { lang } from '@sc/data-access-models';

export enum EnumBooleanKey {
  FORCE_LOGOUT = 'forcelogout',
  CALENDAR_APPOINTMENT_DEFAULT_VIEW = 'calendar-appointment-default-view',
  CALENDAR_DISPLAY_CANCELLED = 'calendar-display-cancelled',
  IS_DOSSIER_ACCESS = 'is-dossier-access',
}
export enum EnumStringKey {
  CLIENT_KEY = 'client-key',
  DOSSIER_NUMBER_SESSION_STORAGE = 'dossier-number',
  REFRESH_TOKEN = 'refresh-token',
  ACCOUNT_LOGIN = 'account-login',
  ACCOUNT_FIRST_NAME = 'account-first-name',
  ACCOUNT_LAST_NAME = 'account-last-name',
  ENCRYPTED_INFO = 'encrypted-info',
  AGENDA_CALENDAR_MODE = 'agenda-calendar-mode',
  SEARCH_FILTER_GROUP_BY = 'search-filter-group-by',
  REDIRECT_URI = 'redirect-uri',
  REDIRECT_WCB_URI = 'redirect-wcb-uri',
  REDIRECT_EXIT_URI = 'redirect-exit-uri',
  REDIRECT_NA_URI = 'redirect-na-uri',
  ACTION = 'action',
  MODIF_PARAM = 'modif_param',
}
export enum EnumNumberKey {
  SLOT_DURATION = 'slotDuration',
  CALENDAR_DAY_WIDTH = 'calendar-day-width',
  EXPIRE_ACCESS_TOKEN_PERIOD = 'expired-access-token-period',
}
export enum EnumJsonObjectKey {
  SEEN_EXTERNAL_DOSSIERS_BASKET = 'seen-external-dossiers-basket',
  SEEN_APMT_REQUESTS_BASKET = 'seen-apmt-requests-basket',
  SIDEXA_DATA = 'sidexa-data',
  OKTA_TOKEN_STORAGE = 'okta-token-storage',
  CALENDAR_HIDDEN_DAYS = 'calendar-hidden-days',
  CALENDAR_FILTER_VUE = 'calendar-filter-vue',
  CALENDAR_EXTREMITY_SLOT_TIMES = 'calendar-extremity-slot-times',
}
export enum EnumJsonListKey {
  AGENDA_FITTERS_DISPLAYED = 'agenda-fitters-displayed',
  LAST_LOGGED_USERS = 'lastLoggedUsers',
  FITTER_NOTIFICATION_CENTER = 'fitterNotificationCenter',
  AGENDA_RESOURCE_FILTERS = 'agenda-resource-filters',
  AGENDA_ACTIVE_RESOURCES_IN_MULTI = 'agenda-active-resources-in-multi',
  USER_TYPES = 'user-types',
}
// export enum EnumDateKey {}
export enum EnumLangKey {
  DOSSIER_LANGUAGE = 'dossier-language',
}

export type EnumStorageKey =
  | typeof EnumBooleanKey
  | typeof EnumStringKey
  | typeof EnumNumberKey
  | typeof EnumJsonObjectKey
  | typeof EnumJsonListKey
  // | typeof EnumDateKey
  | typeof EnumLangKey;

export type BooleanKey = `${EnumBooleanKey}`;
export type StringKey = `${EnumStringKey}`;
export type NumberKey = `${EnumNumberKey}`;
export type JsonObjectKey = `${EnumJsonObjectKey}`;
export type JsonListKey = `${EnumJsonListKey}`;
// export type DateKey = `${EnumDateKey}`;
export type LangKey = `${EnumLangKey}`;

export type StorageKey =
  | BooleanKey
  | StringKey
  | NumberKey
  | JsonObjectKey
  | JsonListKey
  // | DateKey
  | LangKey;

export type EnumStorageKeyMap<T extends EnumStorageKey> =
  T extends EnumBooleanKey
    ? BooleanKey
    : T extends typeof EnumStringKey
    ? StringKey
    : T extends typeof EnumNumberKey
    ? NumberKey
    : T extends typeof EnumJsonObjectKey
    ? JsonObjectKey
    : T extends typeof EnumJsonListKey
    ? JsonListKey
    : // : T extends typeof EnumDateKey
    // ? DateKey
    T extends typeof EnumLangKey
    ? LangKey
    : never;

export type MapKeys<T extends StorageKey, U = any> = T extends BooleanKey
  ? boolean
  : T extends StringKey
  ? string
  : T extends NumberKey
  ? number
  : T extends JsonObjectKey
  ? U
  : T extends JsonListKey
  ? U[]
  : // : T extends DateKey
  // ? Date
  T extends LangKey
  ? lang
  : never;

export function isKeyType<T extends EnumStorageKey>(
  key: StorageKey,
  keyType: T
): key is EnumStorageKeyMap<T> {
  return Object.values(keyType).includes(key);
}
